import {Languages} from '@shared/languages';
import cn from '@sindresorhus/class-names';

import {SearchBlockType} from '@strapi/types/MainLanding';

import styles from './SearchBlock.module.scss';
import {SearchInput} from './SearchInput/SearchInput';

export const SearchBlock = ({
  requestUrl,
  searchBlock,
  locale,
}: {
  requestUrl: string | undefined;
  searchBlock: SearchBlockType;
  locale?: Languages;
}) => {
  return (
    <div className={styles.search}>
      <h2
        className={cn(styles.title, {[styles.chineseTitle]: locale === 'zh'})}
      >
        {searchBlock?.title ?? 'Найди любимое приложение'}
      </h2>
      <SearchInput
        requestUrl={requestUrl}
        targetLocation="bottom"
        autoFocus={false}
        searchBlock={searchBlock}
      />
    </div>
  );
};
